import shopConfig from '@packages/config';

/**
 * Checks if the given pathname **explicitly** contains one of the supported languages.
 * The supported languages that are checked default to the current shop configuration, but can be overridden.
 *
 * NOTE: This returns `false` for external-facing URLs in the default language of the shop, which don't have a language prefix.
 * */
export const pathnameHasSupportedLanguage = (
  pathname: string,
  supportedLanguages: readonly string[] = shopConfig.i18n.languages,
) => supportedLanguages.some((lang) => pathname.startsWith(`/${lang}/`) || pathname === `/${lang}`);
